/* file description */
import { UseGetTreeData } from './type';
import { useEffect, useState, useRef } from 'react';
import { getModuleRecordListCache, getApiData } from '@/common/asset-apis/assetModel';
import { COLUMN_FROM } from '../../../effects/consts';
import { getPinyin, getFirstPinyin } from './pinyinUtil';
import { cloneDeep } from 'lodash';
import useValuesStore from '@/store/useValuesStore';

export const useGetTreeData: UseGetTreeData = ({ field, form, config, columnFrom, API, onChange, fieldValue, storeValue, rowsData, moduleInfo }) => {
  const { dispatchEvent, destroyEvent, taskInfo } = config.metaStore || {};
  const [treeData, setTreeData] = useState<any[]>([]);
  const [optionData, setOptionData] = useState<any[]>([]);
  const { getValues } = useValuesStore();
  const { label, value, parentName, dataKey, treeId, isFilter, dataType, prefilter, preSort, isOpenApi, apiUrl, parentField, apiKeyList, parentList } = field?.options || {};
  const firstUpdate = useRef(true);
  const [apiParamsList, setapiParamsList] = useState({});
  const [filterList, setfilterList] = useState({});
  const apiRef = useRef({});
  const filterRef = useRef({});
  const optionDataRef = useRef([]);
  useEffect(() => {
    let headData: Record<any, any> = {};
    if (storeValue) {
      Object.keys(storeValue).forEach((key: any) => {
        if (!Array.isArray(storeValue[key])) {
          headData = storeValue[key];
        }
      });
    }
    if (columnFrom === COLUMN_FROM.TABLE) {
      if (rowsData?.[config.rowIndex]) {
        if (isOpenApi) {
          apiKeyList?.forEach((item: any) => {
            if (item.isValueFromMainModule) {
              apiRef.current = { ...apiRef.current, [item.apiKey]: headData?.[item.apiValueModule] };
            } else {
              apiRef.current = { ...apiRef.current, [item.apiKey]: rowsData?.[config.rowIndex]?.[item.apiValue] };
            }
          });
        } else {
          if (parentList?.length > 0) {
            parentList?.forEach((item: any) => {
              filterRef.current = { ...filterRef.current, [item.parentListKey]: config.formValue[config.rowIndex]?.[item.parentListValue] };
            });
          }
          if (parentField && parentName) {
            filterRef.current = { ...filterRef.current, [parentName]: config.formValue[config.rowIndex]?.[parentField] };
          }
        }
      }
    }
    if (columnFrom === COLUMN_FROM.FORM) {
      if (isOpenApi) {
        apiKeyList?.forEach((item: any) => {
          if (item.isValueFromMainModule) {
            apiRef.current = { ...apiRef.current, [item.apiKey]: headData?.[item.apiValueModule] };
          } else {
            apiRef.current = { ...apiRef.current, [item.apiKey]: config.formValue[item.apiValue] };
          }
        });
      } else {
        if (parentList?.length > 0) {
          parentList?.forEach((item: any) => {
            filterRef.current = { ...filterRef.current, [item.parentListKey]: config.formValue?.[item.parentListValue] };
          });
        }
        if (parentField && parentName) {
          filterRef.current = { ...filterRef.current, [parentName]: config.formValue?.[parentField] };
        }
      }
    }

    const mainModuleCode = taskInfo?.modules?.find(
      (module: any) => module.moduleID === taskInfo?.mainModuleId,
    )?.handle;
    const idList: any[] = [];
    if (isOpenApi) {
      apiKeyList?.forEach((item: any) => {
        const events = [{
          code: field.name,
          name: field.label,
          touchConfig: 'change',
          actionType: 'callback',
          moduleName: item.isValueFromMainModule ? mainModuleCode : moduleInfo.handle,
          fieldName: item.isValueFromMainModule ? item.apiValueModule : item.apiValue,
          rowIndex: config.rowIndex,
          fun: (value: any) => {
            apiRef.current = { ...apiRef.current, [item.apiKey]: value };
            onChange && onChange(null);
            setapiParamsList({ ...apiRef.current, [item.apiKey]: value });
          },
        }];
        const ids = dispatchEvent?.(events);
        idList.push(ids);
      });
    } else {
      if (parentList?.length > 0) {
        parentList?.forEach((item: any) => {
          const events = [{
            code: field.name,
            name: field.label,
            touchConfig: 'change',
            actionType: 'callback',
            moduleName: moduleInfo.handle,
            fieldName: item.parentListValue,
            rowIndex: config.rowIndex,
            fun: (value: any) => {
              filterRef.current = { ...filterRef.current, [item.parentListKey]: value };
              onChange && onChange(null);
              setfilterList({ ...filterRef.current, [item.parentListKey]: value });
            },
          }];
          const ids = dispatchEvent?.(events);
          idList.push(ids);
        });
      }

      if (parentField && parentName) {
        const events = [{
          code: field.name,
          name: field.label,
          touchConfig: 'change',
          actionType: 'callback',
          moduleName: moduleInfo.handle,
          fieldName: parentField,
          rowIndex: config.rowIndex,
          // isFormCopyValue  数据是否来自复制页面
          fun: (value: any, { isFormCopyValue }) => {
            filterRef.current = { ...filterRef.current, [parentName]: value };
            setfilterList({ ...filterRef.current, [parentName]: value });
            const values = getValues();
            let oldValue = null;
            Object.keys(values).forEach((key) => {
              if (values[key][field.name]) {
                oldValue = values[key][field.name];
              }
            });
            const list = updatefilterRef(optionDataRef.current)?.map((item: { [x: string]: any }) => item[field.options?.value]);
            if (!list || !list.includes(oldValue)) {
              if (onChange && !isFormCopyValue) {
                onChange(null);
              }
            }
          },
        }];
        const ids = dispatchEvent?.(events);
        idList.push(ids);
      }
    }
    return () => {
      idList?.forEach((ids: any) => {
        destroyEvent?.(ids);
      });
    };
  }, []);

  const convert = (data: any) => {
    const obj: Record<any, any> = {};
    data.values && data.values.forEach((item: any) => {
      obj[item.name] = item.value;
    });
    return obj;
  };

  // 获取下拉数据
  useEffect(() => {
    if (isOpenApi) {
      return;
    }
    const params: Record<any, any> = {
      moduleID: dataKey,
      namespaceID: treeId,
      limit: 3000,
    };
    if (preSort) {
      params.sort = preSort;
    }
    if (isFilter) {
      const otherFilter = dataType || prefilter || '';
      params.filter = otherFilter;
    } else {
      params.filter = '';
    }
    getModuleRecordListCache(API?.FetchAPI, treeId, dataKey, params).then((res: any) => {
      const { set = [] } = res || {};
      setOptionData(set);
      optionDataRef.current = set;
    });
  }, []);

  // useEffect(() => {
  //   if (firstUpdate.current) {
  //     // 初始化时可能会加载多次，导致清空值。后续全局优化
  //     setTimeout(() => {
  //       firstUpdate.current = false;
  //     }, 1000);
  //   } else {
  //     onChange && onChange(null);
  //     // (fieldValue && onChange) && onChange(null);
  //   }
  // }, [JSON.stringify(filterRef.current), JSON.stringify(apiRef.current)]);
  const updatefilterRef = (newOptionData: any[]) => {
    if (newOptionData.length > 0) {
      const filterData = newOptionData.filter((item: any) => {
        const { values = [] } = item || {};
        if (Object.keys(filterRef.current)?.length > 0) {
          return Object.keys(filterRef.current).every((key: string) => {
            return filterRef.current[key] === values.find((v: any) => v.name === key)?.value;
          });
        } else {
          return true;
        }
        // return parentValue === values.find((v: any) => v.name === parentName)?.value;
      });
      const mapData = filterData.map((item: any) => {
        const { values = [] } = item || {};
        const converData = convert(item);
        const tLabel = values.find((v: any) => v.name === label)?.value;
        const tValue = values.find((v: any) => v.name === value)?.value;
        const fullPY = getPinyin(tLabel);
        const firstPY = getFirstPinyin(tLabel);
        return {
          ...converData,
          label: tLabel,
          value: typeof tValue === 'number' ? tValue.toString() : tValue,
          fullPY,
          firstPY,
        };
      });
      const filterMap = new Map();
      return (mapData.filter((item: any) => !filterMap.has(item.value) && filterMap.set(item.value, 1)));
    }
  };
  useEffect(() => {
    if (isOpenApi) {
      getApiData(API?.FetchAPI, apiUrl, apiRef.current).then((res: any) => {
        const { set = [] } = res || {};
        const mapData = set.map((item: any) => {
          const { values = [] } = item || {};
          const converData = convert(item);
          const tLabel = values.find((v: any) => v.name === label)?.value;
          const tValue = values.find((v: any) => v.name === value)?.value;
          const fullPY = getPinyin(tLabel);
          const firstPY = getFirstPinyin(tLabel);
          return {
            ...converData,
            label: tLabel,
            value: tValue,
            fullPY,
            firstPY,
          };
        });
        setTreeData(mapData);
      });
    }
    if (optionData.length > 0) {
      const data = updatefilterRef(optionData);
      setTreeData(data);
    }
  }, [JSON.stringify(filterRef.current), optionData, JSON.stringify(apiRef.current)]);

  return {
    treeData,
  };
};
